/** Settings → Preferences → AI tools. */
export default {
  runsInDesktopApp: "Runs in the desktop app",
  download: "Download",
  notSignedIn: "Not signed in",
  signIn: "Sign in",
  update: "Update",
  aiUsageThisMonth: "AI usage this month",
  runsStartedThisMonth: "Runs started this month",
  tokens: { one: "{formatted} token", other: "{formatted} tokens" },
} as const;
